module.exports = __webpack_public_path__ + "img/accessory_pants_04.eba73d7f.svg";